export const defaultFilters = () => ({
  pagination: {
    limit: 50,
    page: 1,
  },
  search: '',
  status: 'active',
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: false,
  },
})

export const defaultCohorts = () => ({
  reg_no_dep: { enabled: false, segment_name: '', within_days: 90 },
  depositors: { enabled: false, segment_name: '', within_days: 180 },
  clicks_no_reg: { enabled: false, segment_name: '', within_days: 30 },
})

export const defaultScope = () => ({
  advertiser_ids: [],
  advertiser_ids_exclude: [],
  offer_ids: [],
  offer_ids_exclude: [],
  country_ids: [],
  country_ids_exclude: [],
  actual_country_ids: [],
  actual_country_ids_exclude: [],
  partner_ids: [],
  partner_ids_exclude: [],
  partner_group_ids: [],
  partner_group_ids_exclude: [],
  stream_ids: [],
  stream_ids_exclude: [],
  traffic_source_ids: [],
  traffic_source_ids_exclude: [],
  payment_model_ids: [],
  payment_model_ids_exclude: [],
})

// CPA-3455: 400 "cohorts.segment_name is already used by another audience: <name>, <name>" → [names]
const TAKEN_SEGMENT_PREFIX = 'cohorts.segment_name is already used by another audience:'
export function parseTakenSegmentNames(error) {
  const message = error?.response?.data?.message
  if (typeof message !== 'string' || !message.startsWith(TAKEN_SEGMENT_PREFIX)) return []
  return message
    .slice(TAKEN_SEGMENT_PREFIX.length)
    .split(',')
    .map(name => name.trim())
    .filter(Boolean)
}
